import PropTypes from "prop-types";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import clsx from "clsx";
import { useEffect } from "react";
import MenuCart from "./sub-components/MenuCart";
import { 
  logoutUser, 
  selectCartState, 
  selectIsUserLoggedIn, 
  selectIsAdminLoggedIn,
  selectCompanyIsUse,
  selectWithcookieData
} from "../../../../redux/WithcookieSlice";

const IconGroup = ({ iconWhiteClass, textStyle }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const handleClick = e => {
    e.currentTarget.nextSibling.classList.toggle("active");
  };

  const triggerMobileMenu = () => {
    const offcanvasMobileMenu = document.querySelector(
      "#offcanvas-mobile-menu"
    );
    offcanvasMobileMenu.classList.add("active");
  };
  
  const { compareItems } = useSelector((state) => state.compare || { compareItems: [] });
  const { wishlistItems } = useSelector((state) => state.wishlist || { wishlistItems: [] });
  const { cartItems } = useSelector(selectCartState);
  
  // 로그인 상태 확인
  const isUserLoggedIn = useSelector(selectIsUserLoggedIn);
  const isAdminLoggedIn = useSelector(selectIsAdminLoggedIn);
  const isLoggedIn = isUserLoggedIn || isAdminLoggedIn;
  
  // withcookieData에서 회사 정보 가져오기
  const withcookieData = useSelector(selectWithcookieData);
  
  // company 쇼핑 기능 사용 여부 확인 - company.useShop 값을 우선 사용
  const companyIsUse = useSelector(selectCompanyIsUse);
  const companyUseShop = withcookieData?.company?.useShop || 
                          withcookieData?.skin?.company?.useShop;
  
  // useShop 값이 명시적으로 false인 경우에만 장바구니 숨김, 그 외에는 표시
  const useShop = companyUseShop !== false;
  
  // 장바구니 페이지로 이동 처리
  const handleCartClick = (e) => {
    e.preventDefault();
    navigate('/cart');
  };
  
  // 로그인 페이지로 이동 처리
  const handleLoginClick = (e) => {
    e.preventDefault();
    navigate('/login');
  };
  
  // 로그아웃 처리 함수
  const handleLogout = (e) => {
    e.preventDefault();
    dispatch(logoutUser()).then(() => {
      // 로그아웃 성공 후 홈 페이지로 이동
      navigate('/');
    });
  };

  // 아이콘 스타일 설정
  const iconStyle = textStyle ? { color: textStyle.color } : {};

  return (
    <div className={clsx("header-right-wrap", iconWhiteClass)} style={textStyle}>
      {/* <div className="same-style header-search d-none d-lg-block">
        <button className="search-active" onClick={e => handleClick(e)} style={iconStyle}>
          <i className="pe-7s-search" />
        </button>
        <div className="search-content">
          <form action="#">
            <input type="text" placeholder="Search" />
            <button className="button-search">
              <i className="pe-7s-search" />
            </button>
          </form>
        </div>
      </div> */}
      <div className="same-style account-setting d-none d-lg-block">
        {isLoggedIn ? (
          // 로그인 상태: 로그아웃 버튼
          <button
            className="account-setting-active"
            onClick={handleLogout}
            style={iconStyle}
            title="로그아웃"
          >
            <img 
              src={process.env.PUBLIC_URL + "/logout_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg"} 
              alt="Logout"
              style={{ width: '24px', height: '24px' }}
            />
          </button>
        ) : (
          // 비로그인 상태: 기존 로그인 버튼
          <button
            className="account-setting-active"
            onClick={handleLoginClick}
            style={iconStyle}
          >
            <img 
              src={process.env.PUBLIC_URL + "/login_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg"} 
              alt="Login"
              style={{ width: '24px', height: '24px' }}
            />
          </button>
        )}
        {/* 
!isLoggedIn && (
          <div className="account-dropdown">
            <ul>
              <li>
                <Link to={process.env.PUBLIC_URL + "/login-register"}>Login</Link>
              </li>
              <li>
                <Link to={process.env.PUBLIC_URL + "/login-register"}>
                  Register
                </Link>
              </li>
              <li>
                <Link to={process.env.PUBLIC_URL + "/my-account"}>
                  my account
                </Link>
              </li>
            </ul>
          </div>
        )
*/}
      </div>
      {/* <div className="same-style header-compare">
        <Link to={process.env.PUBLIC_URL + "/compare"} style={iconStyle}>
          <i className="pe-7s-shuffle" />
          <span className="count-style" style={textStyle}>
            {compareItems && compareItems.length ? compareItems.length : 0}
          </span>
        </Link>
      </div>
      <div className="same-style header-wishlist">
        <Link to={process.env.PUBLIC_URL + "/wishlist"} style={iconStyle}>
          <i className="pe-7s-like" />
          <span className="count-style" style={textStyle}>
            {wishlistItems && wishlistItems.length ? wishlistItems.length : 0}
          </span>
        </Link>
      </div> */}
      {useShop && (
        <div className="same-style cart-wrap d-none d-lg-block">
          <button className="icon-cart" onClick={handleCartClick} style={iconStyle}>
            <img 
              src={process.env.PUBLIC_URL + "/shopping_cart_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg"} 
              alt="Cart"
              style={{ width: '24px', height: '24px' }}
            />
            <span className="count-style" style={textStyle}>
              {cartItems && cartItems.length ? cartItems.length : 0}
            </span>
          </button>
          {/* menu cart */}
          <MenuCart />
        </div>
      )}
      {useShop && (
        <div className="same-style cart-wrap d-block d-lg-none" v-if="">
          <Link className="icon-cart" to="/cart" style={iconStyle}>
            <img 
              src={process.env.PUBLIC_URL + "/shopping_cart_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg"} 
              alt="Cart"
              style={{ width: '24px', height: '24px' }}
            />
            <span className="count-style" style={textStyle}>
              {cartItems && cartItems.length ? cartItems.length : 0}
            </span>
          </Link>
        </div>
      )}
      <div className="same-style mobile-off-canvas d-block d-lg-none">
        <button
          className="mobile-aside-button"
          onClick={() => triggerMobileMenu()}
          style={iconStyle}
        >
          <img 
            src={process.env.PUBLIC_URL + "/menu_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg"} 
            alt="Menu"
            style={{ width: '24px', height: '24px' }}
          />
        </button>
      </div>
    </div>
  );
};

IconGroup.propTypes = {
  iconWhiteClass: PropTypes.string,
  textStyle: PropTypes.object
};

export default IconGroup;
